import { Button, Form, Modal, Row, Space, Table } from 'antd';
import React, { useEffect, useImperativeHandle, useState } from 'react';
import { InputFields } from 'components/common';
import { inputFields } from './config';

const GroupVTYTModal = React.forwardRef((props, ref) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [data, setData] = useState<any>(null);
  const [type, setType] = useState<number>(0); // 0 post , 1 put
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
    setData: setData
  }))
  const openModal = async () => {
    setIsModalOpen(true);
  }
  const closeModal = async () => {
    setIsModalOpen(false);
  }

  const onSave = async () => {
    form.validateFields().then(async values => {
      if( type === 0) {
        delete values["id"];
      }
      props.onSave({
        ...values
      }, type);
      closeModal();
    })
  }
  useEffect(() => {
    if(data) {
      setType(1);
      form.setFieldsValue({
        ...data
      })
    }
    else {
      setType(0)
      form.resetFields()
    }
  }, [data])
  useEffect(() => {
  }, [isModalOpen])
  return (
    <div className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
				title={type === 0 ? "Thêm mới nhóm dịch vụ kỹ thuật": "Sửa nhóm dịch vụ kỹ thuật"}
        width={960}
			>
        <Row>
          <Form form={form}>
            <Space direction='vertical' style={{width: "100%"}}>
              <Row gutter={[8, 8]}>
                <InputFields data={inputFields()} />
              </Row>
              <Row justify={"end"} style={{gap: "4px"}}>
                <Button danger type="primary" onClick={closeModal}>Huỷ</Button>
                <Button type="primary" onClick={onSave}>Lưu</Button>
              </Row>
            </Space>
          </Form>
        </Row>
      </Modal>
    </div>
  );
})

export default GroupVTYTModal;